module.exports = __webpack_public_path__ + "img/thumb-flappy.3c6493d6.png";